<template>
  <li class="item">
    <!-- D: video sample -->
    <template v-if="props.link.linkUrlSeCd === 'U'">
      <iframe
        :src="youtubeUrl"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
      ></iframe>
    </template>
    <template v-else-if="props.link.linkUrlSeCd === 'V'">
      <iframe
        :src="vimeoUrl"
        width="640"
        height="360"
        frameborder="0"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen
      ></iframe>
    </template>
  </li>
</template>
<script setup>
import { computed, defineProps, onMounted } from "vue";

const props = defineProps({
  link: {
    type: Object,
    required: true,
  },
});

onMounted(() => {});

const youtubeUrl = computed(() => {
  const regx = /youtu\.be\/(\w+)/;

  const match = props.link.linkUrl.match(regx);
  const videoId = match[1];

  return `https://www.youtube.com/embed/${videoId}?si=X9pSLalf4hvc_Dxq`;
});

const vimeoUrl = computed(() => {
  const regx = /vimeo\.com\/(\d+)/;

  const match = props.link.linkUrl.match(regx);
  const videoId = match[1];

  return `https://player.vimeo.com/video/${videoId}`;
});
</script>
